/* eslint-disable import/first */
import React from 'react';
import Hreflang from '../../components/Hreflang';
import { Redux, Slices } from 'spwa-ui-library';
import { Grid } from '@material-ui/core';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import Loader from '../../components/Loader';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';
import { useIntl } from 'react-intl';
const { useSelector } = Redux;

const { selectCurrentCountry } = Slices.profileSlice;
function NutritionInfo() {
  const intl = useIntl();
  const currentCountry = useSelector(selectCurrentCountry);

  return (
    <Grid>
      <Hreflang page={'nutritionInfo'} />
      <Header
        title={
          <FormattedMessage
            id="navigation_nutritionInformation"
            defaultMessage="nutritionInformation"
          />
        }
        actionButtons={[<LanguageButton />]}
      />
      <div>
        <div className={css.loader}>
          <Loader shadow={false} />
        </div>
        <iframe
          //   type="application/pdf"
          src={`https://phwebterms.azureedge.net/${
            currentCountry?.toLowerCase() || currentCountry || 'uae'
          }/${intl.locale}/nutrition.html`}
          width="100%"
          height="100%"
          allowtransparency="true"
          title="pdf"
        ></iframe>
      </div>
      <footer></footer>
    </Grid>
  );
}

export default NutritionInfo;
